import _ from './app-footer.module.scss'
import React from 'react'
import {Container} from './container'
import {Flex} from './flex'
import {$, $$$} from '../shared/class-name'
import {useIs1024} from '../hooks/use-is-1024'
import {useIsMobile} from '../hooks/use-is-mobile'
import {Link, useLocation} from 'react-router-dom'
import {getNavigationState} from '../shared/navigation-state'
import {getAppFooterVisible} from '../shared/layout-dynamics'
import {isLegalPath, LEGAL_PATHS} from '../apps/outof195/modules/legal/legal-paths'
import {Logo, Mark} from './brand'

export const AppFooter = ({className}) => {
    const location = useLocation()
    const {pathname} = location
    const withinLegal = isLegalPath(pathname)
    const navigationState = withinLegal ? location.state : getNavigationState(location)
    const is1024 = useIs1024()
    const isMobile = useIsMobile()
    if (!getAppFooterVisible(pathname, {isMobile})) return null
    return <Container className={$$$($(className))}>
        <footer className={$$$(_.root, $(_.auth, pathname.includes('/auth')))}>
            <Flex column gap={8}>
                <Flex gap={6}>
                    <Mark logo secondary/>
                    <span>©</span>
                    <span>2026 by </span>
                    <span className={_.author}>レ  ク  サ  ー</span>
                </Flex>
                <Flex gap={16} className={_.links}>
                    <Link to={LEGAL_PATHS.terms} state={navigationState} replace={withinLegal}>Terms</Link>
                    <Link to={LEGAL_PATHS.privacy} state={navigationState} replace={withinLegal}>Privacy</Link>
                    <Link to={LEGAL_PATHS.communityGuidelines} state={navigationState} replace={withinLegal}>Community Guidelines</Link>
                    <Link to={LEGAL_PATHS.cookies} state={navigationState} replace={withinLegal}>Cookies</Link>
                    <Link to={LEGAL_PATHS.report} state={navigationState} replace={withinLegal}>Report</Link>
                </Flex>

            </Flex>
        </footer>
    </Container>
}
